import React from 'react'
import PropTypes from 'prop-types'

/// @material-ui/core components
import List from '@material-ui/core/List'
import withStyles from '@material-ui/core/styles/withStyles'

import ListItem from 'components/List/ListItem'
import ListHeader from 'components/List/ListHeader'

const style = theme => ({
  list: { ...theme.list },
})

const RichList = ({ classes, items, ...rest }) => {
  return (
    <>
      <ListHeader {...rest} />
      <List dense={true} className={classes.list}>
        {items.map(listItem => {
          const computedId = listItem.id || listItem.title || listItem.url
          return <ListItem key={computedId} {...listItem} />
        })}
      </List>
    </>
  )
}

RichList.defaultProps = {
  items: [],
  title: '',
  subtitle: '',
}

RichList.propTypes = {
  classes: PropTypes.object.isRequired,
  items: PropTypes.array,
  title: PropTypes.string,
  subtitle: PropTypes.string,
}

export default withStyles(style)(RichList)
